import React from 'react';
import { HeaderPDF } from 'src/assets/Images';
import { Header, HeaderLogo } from './styles';
export var PDFHeader = function () { return (React.createElement(Header, { fixed: true },
    React.createElement(HeaderLogo, { src: HeaderPDF }))); };
export default PDFHeader;
